import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Routing from './components/Routes';

import './App.css';

const App = () => {

  return (
    <div className="app-shell">
        <Header />
        <main id="app" className="app-main">
          <Routing />
        </main>
        <Footer />
        <CookieConsent />
    </div>
  );
}

export default App;